import { normaliseDateRange } from '@packages/rate-plans/utils/currentSubscription';

import clock from '@plugins/dayjs';
import i18n from '@plugins/i18n';

export function formatSubscriptionPeriod(dateRange) {
    const range = normaliseDateRange(dateRange);

    if (!range?.start) {
        return null;
    }

    const start = clock(range.start).format('Do MMM YYYY');

    if (!range.end) {
        return `${start} – ${i18n.t('_page.investor_billing_panel.subscription_period_ongoing')}`;
    }

    return `${start} – ${clock(range.end).format('Do MMM YYYY')}`;
}

export default formatSubscriptionPeriod;
